import { formatPrice } from "../common/utils";
import FilterParamsUtil from "../sections/collection-grid/filter-params-util";
import CollectionFilterSpKeywords from "./collection-filter-sp/collection-filter-sp-keywords";
import CollectionFilterSpCategories from "./collection-filter-sp/collection-filter-sp-categories";
import CollectionFilterSpBrands from "./collection-filter-sp/collection-filter-sp-brands";
import CollectionFilterSpColors from "./collection-filter-sp/collection-filter-sp-colors";
import CollectionFilterSpSizes from "./collection-filter-sp/collection-filter-sp-sizes";
import CollectionFilterSpSalesTypes from "./collection-filter-sp/collection-filter-sp-sales-types";
import CollectionFilterSpPriceRange from "./collection-filter-sp/collection-filter-sp-price-range";
import CollectionFilterSpDetails from "./collection-filter-sp/collection-filter-sp-details";
import CollectionFilterSpInventory from "./collection-filter-sp/collection-filter-sp-inventory";

const CollectionFilterSp = (el, sectionParams, onChangeFilterParams) => {
  let filterParams = [];
  let keywords = null;
  let categories = null;
  let brands = null;
  let colors = null;
  let sizes = null;
  let priceRange = null;
  let salesTypes = null;
  let details = null;
  let inventory = null;

  const initialize = () => {
    el.querySelector(".fs-collection-filter-sp-drawer .fs-header .fs-close-button").addEventListener("click", () => {
      el.classList.remove("show");
    });
    el.querySelector(".fs-collection-filter-sp-drawer .fs-footer .fs-clear-button").addEventListener("click", () => {
      const keys = [
        "q",
        "product_type",
        "vendor",
        "meta.custom.search_color",
        "meta.custom.search_size",
        "price_min",
        "price_max",
        "meta.custom.sales_type",
        "meta.custom.detail_sleeve",
        "meta.custom.detail_length",
        "detail_length_min",
        "detail_length_max",
        "meta.custom.detail_silhouette",
        "collections",
      ];
      const newFilterParams = filterParams.filter((kv) => !keys.includes(kv.key));
      handleChangeFilterParams(newFilterParams);
    });
    el.querySelector(".fs-collection-filter-sp-drawer .fs-footer .fs-select-button").addEventListener("click", () => {
      onChangeFilterParams(filterParams);
      el.classList.remove("show");
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });

    const elKeywords = el.querySelector(".fs-collection-filter-sp-keywords");
    if (elKeywords) {
      keywords = CollectionFilterSpKeywords(elKeywords, handleChangeFilterParams);
    }
    el.querySelector("a.fs-row.categories").addEventListener("click", () => {
      categories?.show(filterParams);
    });
    const elCategories = el.querySelector(".fs-collection-filter-sp-categories");
    if (elCategories) {
      categories = CollectionFilterSpCategories(elCategories, sectionParams, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.brands").addEventListener("click", () => {
      brands?.show(filterParams);
    });
    const elBrands = el.querySelector(".fs-collection-filter-sp-brands");
    if (elBrands) {
      brands = CollectionFilterSpBrands(elBrands, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.colors").addEventListener("click", () => {
      colors?.show(filterParams);
    });
    const elColors = el.querySelector(".fs-collection-filter-sp-colors");
    if (elColors) {
      colors = CollectionFilterSpColors(elColors, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.sizes").addEventListener("click", () => {
      sizes?.show(filterParams);
    });
    const elSizes = el.querySelector(".fs-collection-filter-sp-sizes");
    if (elSizes) {
      sizes = CollectionFilterSpSizes(elSizes, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.price-range").addEventListener("click", () => {
      priceRange?.show(filterParams);
    });
    const elPriceRange = el.querySelector(".fs-collection-filter-sp-price-range");
    if (elPriceRange) {
      priceRange = CollectionFilterSpPriceRange(elPriceRange, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.sales-types").addEventListener("click", () => {
      salesTypes?.show(filterParams);
    });
    const elSalesTypes = el.querySelector(".fs-collection-filter-sp-sales-types");
    if (elSalesTypes) {
      salesTypes = CollectionFilterSpSalesTypes(elSalesTypes, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.details").addEventListener("click", () => {
      details?.show(filterParams);
    });
    const elDetails = el.querySelector(".fs-collection-filter-sp-details");
    if (elDetails) {
      details = CollectionFilterSpDetails(elDetails, handleSubmenuClose);
    }
    el.querySelector("a.fs-row.inventory").addEventListener("click", () => {
      inventory?.show(filterParams);
    });
    const elInventory = el.querySelector(".fs-collection-filter-sp-inventory");
    if (elInventory) {
      inventory = CollectionFilterSpInventory(elInventory, handleSubmenuClose);
    }
  };

  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams);
    handleChangeFilterParams(filterParams);
    el.classList.add("show");
  };

  const handleSubmenuClose = (closeFilter, newFilterParams) => {
    if (newFilterParams) {
      handleChangeFilterParams(newFilterParams);
    }
    if (closeFilter) {
      el.classList.remove("show");
    }
  };

  const handleChangeFilterParams = (newFilterParams) => {
    keywords?.setFilterParams(newFilterParams);

    const items = [
      ["a.fs-row.categories .fs-value", "collections"],
      ["a.fs-row.brands .fs-value", "vendor"],
      ["a.fs-row.colors .fs-value", "meta.custom.search_color"],
      ["a.fs-row.sizes .fs-value", "meta.custom.search_size"],
      ["a.fs-row.sales-types .fs-value", "meta.custom.sales_type"],
    ];
    items.forEach((item) => {
      const text = newFilterParams
        .filter((kv) => kv.key == item[1])
        .map((kv) => kv.value)
        .join(", ");
      el.querySelector(item[0]).textContent = 0 < text.length ? text : "指定なし";
    });

    const min = newFilterParams.find((kv) => kv.key == "price_min");
    const minText = min ? formatPrice(parseInt(min.value)) : "";
    const max = newFilterParams.find((kv) => kv.key == "price_max");
    const maxText = max ? formatPrice(parseInt(max.value)) : "";
    if (min || max) {
      el.querySelector("a.fs-row.price-range .fs-value").textContent = `${minText}〜${maxText}`;
    } else {
      el.querySelector("a.fs-row.price-range .fs-value").textContent = "指定なし";
    }

    let details = [];
    const keys1 = ["meta.custom.detail_sleeve", "meta.custom.detail_length"];
    details = details.concat(newFilterParams.filter((kv) => keys1.includes(kv.key)).map((kv) => kv.value));

    const lengthMin = newFilterParams.find((kv) => kv.key == "detail_length_min");
    const lengthMinText = lengthMin ? `${lengthMin.value}cm` : "";
    const lengthMax = newFilterParams.find((kv) => kv.key == "detail_length_max");
    const lengthMaxText = lengthMax ? `${lengthMax.value}cm` : "";
    if (lengthMin || lengthMax) {
      details.push(`着丈${lengthMinText}〜${lengthMaxText}`);
    }

    const keys2 = ["meta.custom.detail_silhouette"];
    details = details.concat(newFilterParams.filter((kv) => keys2.includes(kv.key)).map((kv) => kv.value));

    el.querySelector("a.fs-row.details .fs-value").textContent = 0 < details.length ? details.join(", ") : "指定なし";

    const inventoryText =
      0 <= newFilterParams.findIndex((kv) => kv.key == "inventory_available") ? "在庫あり" : "指定なし";
    el.querySelector("a.fs-row.inventory .fs-value").textContent = inventoryText;

    filterParams = newFilterParams;
  };

  initialize();

  return {
    show: show,
  };
};

export default CollectionFilterSp;
